/* The delay duration in milliseconds for debounced search fields so that we can reduce
 * the number of requests sent to backend when user types text into the search fields. */
export const SEARCH_DELAY_MS = 700;
